module.exports = __webpack_public_path__ + "static/hand-of-vecna-mtg_afr-d17b6bbfd3e760949de74663e7c56143.jpg";